import React, { FunctionComponent, ReactNode } from 'react';
import styled from 'styled-components';
import IconSearch from '@views/static/search.svg';

const Block = styled.div`
  min-height: 60vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: var(--white);
  border-radius: var(--radius);
  margin-bottom: 1.425rem;
`;
const Header = styled.h2`
  font-size: 2rem;
  @media (max-width: 575.98px) {
    font-size: 1.5rem;
  }
`;
const Text = styled.p`
  font-size: 1.25rem;
  @media (max-width: 575.98px) {
    font-size: 1rem;
  }
`;
const IconBlock = styled.div`
  svg {
    max-width: 60px;
    fill: var(--dark);
  }
`;

interface EmptyStateProps {
  title?: string;
  message?: string | ReactNode;
  icon?: ReactNode;
}
export const EmptyState: FunctionComponent<EmptyStateProps> = ({
  title,
  message,
  icon,
}) => (
  <Block>
    <div className="mb-4 text-center">
      <IconBlock className="ml-md-4 mt-4 mb-4 pt-4 pt-md-0">{icon}</IconBlock>
      <div className="not-found mt-4">
        <Header className="not-found__title not-found__title--v2">
          {title}
        </Header>
        <Text className="not-found__text not-found__text--v2">{message}</Text>
      </div>
    </div>
  </Block>
);

EmptyState.defaultProps = {
  icon: <IconSearch />,
};

export default EmptyState;
